import React from 'react';
import PropTypes from 'prop-types';
import Link from 'components/Link';
import makeRequest from 'utils/makeRequest';
import classNames from 'classnames';
// import SocialSharingMobile from 'routes/articleshow_v2/components/mobile/SocialSharingMobile';
import s from './Iplwidget.scss';
import ArticleshowInsertSchedule from '../../../../articleshow/components/ArticleshowIPLWidgets/ArticleshowInsertIPLSchedule/ArticleshowInsertSchedule';
// import NotificationHooksWraper from '../../../../liveblog_v2/components/common/NotificationHooksWraper';
// import { TOI_LIVE_DOMAIN } from '../../../../../constants';
// const featuredCardIndex = 0;

class Iplwidget extends React.Component {
  constructor() {
    super();
    this.state = {
      widgetsData: undefined,
      apiURL: undefined,
    };
  }
  componentDidMount() {
    if (this.props.apiURL) {
      this.setState({
        apiURL: this.props.apiURL,
      });
      this.refreshData(this.props.apiURL);
    }
  }
  refreshTimer = null;
  refreshData = api => {
    const apiurl = this.state.apiURL || api;
    if (apiurl) {
      makeRequest
        .get(apiurl, { isMobile: true })
        .then(data => {
          if (data && data.status === 200 && data.data) {
            this.setState({
              widgetsData: data.data,
            });
          }
        })

        .catch(err => console.error(err));
    }
  };
  render() {
    const { sectionData = { data: [] } } = this.props;
    const sectionDataItems = sectionData.items || sectionData.data;
    const {
      widgetsData = {
        schedule: {},
      },
    } = this.state;
    const linkDetails = [];
    const categoryPrefix = this.props.isWapView ? 'WAP' : 'WEB';
    // const sharePageUrl = `${TOI_LIVE_DOMAIN}${sectionData.link}`;
    // const { showWhatsappNativeShareTP } = this.props;
    // const notificationWidgetData = {
    //   subscribeButtonText: 'Subscribe to get live updates',
    //   frmiplwidget: true,
    // };
    if (Array.isArray(sectionDataItems)) {
      sectionDataItems.map((childI = {}) => {
        switch (childI.tn) {
          case 'links_details': {
            if (Array.isArray(childI.footerData)) {
              childI.footerData.forEach(ci => {
                linkDetails.push(
                  <Link
                    href={ci.url}
                    className={s.opt_item}
                    data-newga={`${this.props.gaWidgetAction}#click_${ci.name}`}
                  >
                    <i
                      className={classNames({
                        [s.icons]: true,
                        [s.schedule]: ci.name === 'schedule',
                        [s.teams]: ci.name === 'teams',
                        [s.videos]: ci.name === 'videos',
                        [s.stats]: ci.name === 'stats',
                        [s.news]: ci.name === 'news',
                        [s.photos]: ci.name === 'photos',
                        [s.standings]: ci.name === 'standings',
                      })}
                    />
                    {ci.name}
                  </Link>,
                );
              });
            }
            break;
          }
          default: {
            return null;
          }
        }
        return null;
      });
    }
    return (
      <div className={s.sportsWidget} data-scrollga={this.props.gaEventAction}>
        <h4>
          <Link
            to={sectionData.link}
            key={sectionData.id}
            data-newga={`${this.props.gaWidgetAction}#click_lp`}
          >
            {sectionData.name}
          </Link>
        </h4>
        {widgetsData.schedule.matches && (
          <ArticleshowInsertSchedule
            data={this.state.widgetsData.schedule}
            apiURL={sectionData.path}
            isWapView={this.props.isWapView}
            refreshData={this.refreshData}
            refreshTimer={this.refreshTimer}
            categoryPrefix={categoryPrefix}
            showScheduleLink={false}
            gaEventCategory={this.props.gaEventCategory}
            gaEventAction={this.props.gaWidgetAction}
            removeDots
          />
        )}
        <div className={s.scr_crd_options}>{linkDetails}</div>
        {/* <div className={s.noti_social}>
          <NotificationHooksWraper
            data={notificationWidgetData}
            isWapView={this.props.isWapView}
            hideNotificationText
            hideNotificationImage
          />
          <>
            {!this.props.isAppView && (
              <div
                className={s.social_icons}
                data-socialshare="57119947"
                ref={this.shareRef}
              >
                <SocialSharingMobile
                  msid="57119947"
                  title={sectionData.name}
                  url={sharePageUrl}
                  wu={sharePageUrl}
                  isParent
                  via="@timesofindia"
                  topsticky
                  wrapperClass="homepageIplWidget"
                  //textRequired="false"
                  //tpShow="false"
                  showWhatsappNativeShareTP={showWhatsappNativeShareTP}
                  linkeDin={!showWhatsappNativeShareTP}
                  isWapView={this.props.isWapView}
                  gaCategory={this.props.gaEventCategory}
                  gaAction="ipl_widget_share"
                  liveblogMailHeading="Mail this story"
                  utm="&source=share&medium=####&campaign=ipl_widget"
                />
              </div>
            )}
          </>
        </div> */}
      </div>
    );
  }
}

Iplwidget.propTypes = {
  sectionData: PropTypes.shape({}).isRequired,
  isWapView: PropTypes.bool,
  // showWhatsappNativeShareTP: PropTypes.bool,
  apiURL: PropTypes.string,
  gaEventCategory: PropTypes.string,
  gaEventAction: PropTypes.string,
  gaWidgetAction: PropTypes.string,
};

Iplwidget.defaultProps = {
  isWapView: true,
  // showWhatsappNativeShareTP: true,
  apiURL: undefined,
  gaEventCategory: '-US-NHP1',
  gaEventAction: 'Scroll_Section_View-IPLEnds',
  gaWidgetAction: 'CW23_Widget_Actions',
};

export default Iplwidget;
